module.exports = {
  qqgdscpjypt:
    "世界ハイエンド水産物取引プラットフォーム(及び深セン国際マグロ取引有限公司)です。",
};



// WEBPACK FOOTER //
// ./src/lang/ja.js